import React from "react";
import { FaArrowAltCircleDown } from "react-icons/fa";

const OurCommitment = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* Glow Orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 flex flex-col items-center text-center">
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-slate-800"
          data-aos="fade-up"
        >
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
            Your Goals,
          </span>{" "}
          Our Commitment ⚡
        </h1>

        <p
          className="mt-4 text-slate-600 text-base md:text-lg lg:text-xl font-medium max-w-3xl"
          data-aos="fade-up"
        >
          With Online & Offline Courses, Internships, and Real-world Live
          Projects.
        </p>

        <p
          className="mt-6 text-slate-700 font-normal text-sm md:text-base leading-relaxed max-w-3xl"
          data-aos="fade-up"
        >
          At <span className="font-semibold">Web Rocket Classes</span>, we are
          committed to delivering top-quality education through expertly
          designed courses. Our instructors are industry professionals, ensuring
          practical, hands-on knowledge. With flexible learning options,
          mentorship, and career-focused guidance, we help you succeed.
        </p>

        {/* highlight tag */}
        <div
          className="mt-7 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-[#064585] shadow-sm text-sm md:text-base font-medium"
          data-aos="zoom-in"
        >
          Empowering Learners to Become Creators 🚀
        </div>

        {/* Down Arrow */}
        <div
          className="mt-6 flex items-center justify-center"
          data-aos="fade-up"
        >
          <FaArrowAltCircleDown className="text-[#064585] text-4xl md:text-5xl lg:text-6xl animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default OurCommitment;
